package pl.michal_cyran.portfolio.projects.data

val projects = commercialProjects + personal + practiceProjects + academicProjects